// assets/mwc-auth.js

(function () {
  if (window.mwcAuthInitialized) return;
  window.mwcAuthInitialized = true;

  async function runAuth() {
    try {
      const data = await MWC.me();

      const wrappers = document.querySelectorAll(".mwc-auth-wrapper");

      wrappers.forEach(function (wrapper) {
        const login = wrapper.querySelector(".mwc-auth-login");
        const content = wrapper.querySelector(".mwc-auth-content");

        if (!data.logged_in) {
          // Niet ingelogd:
          // login tonen, content verbergen, wrapper zichtbaar houden
          if (wrapper) wrapper.style.display = "block";
          if (login) login.style.display = "block";
          if (content) content.style.display = "none";
        } else {
          // Wel ingelogd:
          // als content leeg is, hele wrapper verbergen
          const isLoginSection = wrapper.hasAttribute("data-mwc-login");

if (login) login.style.display = "none";

if (isLoginSection) {
  const accountBox = wrapper.closest('.customer-account-box');

  if (accountBox) accountBox.style.display = "none";
  if (wrapper) wrapper.style.display = "none";
  if (content) content.style.display = "none";
} else {
  if (login) login.style.display = "none";
  if (content) content.style.display = "block";
}
        }
      });

      if (data.logged_in) {
        document.dispatchEvent(
          new CustomEvent("mwc:authenticated", {
            detail: data
          })
        );
      } else {
        document.dispatchEvent(new CustomEvent("mwc:guest"));
      }

    } catch (e) {
      const wrappers = document.querySelectorAll(".mwc-auth-wrapper");

      wrappers.forEach(function (wrapper) {
        const login = wrapper.querySelector(".mwc-auth-login");
        const content = wrapper.querySelector(".mwc-auth-content");

        if (wrapper) wrapper.style.display = "block";
        if (login) login.style.display = "block";
        if (content) content.style.display = "none";
      });

      document.dispatchEvent(new CustomEvent("mwc:guest"));
    }
  }

  document.addEventListener("DOMContentLoaded", runAuth);
})();